const LocationIcon = () => (
    <svg>
        <use xlinkHref="#locationIconSymbol" />
    </svg>
);

export default LocationIcon;
